import { RRule } from "rrule";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import rrulePlugin from "@fullcalendar/rrule";
import interactionPlugin from "@fullcalendar/interaction";

const calendarElem = document.getElementById("calendar");
if (calendarElem === null) {
  throw Error("element with id `calendar` not found");
}

const calendar = new Calendar(calendarElem, {
  plugins: [rrulePlugin, dayGridPlugin, interactionPlugin],
  initialView: "dayGridMonth",
  height: "auto",
  defaultAllDay: true,
  events: [
    {
      id: "chumhogs-day",
      title: "Chumhog's Day",
      rrule: {
        freq: RRule.YEARLY,
        dtstart: new Date(2021, 1, 2),
      },
    },
    {
      id: "chumsgiving-us",
      title: "Chumsgiving (US)",
      rrule: {
        freq: RRule.YEARLY,
        byweekday: RRule.TH,
        bymonth: [11],
        bysetpos: [4],
      },
    },
    {
      id: "chumsgiving-ca",
      title: "Chumsgiving (CA)",
      rrule: {
        freq: RRule.YEARLY,
        byweekday: RRule.MO,
        bymonth: [10],
        bysetpos: [2],
      },
    },
    {
      id: "chummas-eve",
      title: "Chummas Eve",
      rrule: {
        freq: RRule.YEARLY,
        dtstart: new Date(2021, 11, 24),
      },
    },
    {
      id: "chummas-day",
      title: "Chummas Day",
      rrule: {
        freq: RRule.YEARLY,
        dtstart: new Date(2021, 11, 25),
      },
    },
    {
      id: "chummas-eve-orthodox",
      title: "Orthodox Chummas Eve",
      rrule: {
        freq: RRule.YEARLY,
        dtstart: new Date(2021, 0, 6),
      },
    },
    {
      id: "chummas-day-orthodox",
      title: "Orthodox Chummas Day",
      rrule: {
        freq: RRule.YEARLY,
        dtstart: new Date(2021, 0, 7),
      },
    },
    {
      id: "valenchums-day",
      title: "Valenchum's Day",
      rrule: {
        freq: RRule.YEARLY,
        dtstart: new Date(2021, 1, 14),
      },
    },
    {
      id: "st-chummys-day",
      title: "Saint Chummy's Day",
      rrule: {
        freq: RRule.YEARLY,
        dtstart: new Date(2021, 2, 17),
      },
    },
    {
      id: "cyber-chumday-nov",
      title: "Cyber Chumday",
      rrule: {
        freq: RRule.YEARLY,
        byweekday: RRule.MO,
        bymonth: [11],
        bymonthday: [26, 27, 28, 29, 30],
      },
    },
    {
      id: "cyber-chumday-dec",
      title: "Cyber Chumday",
      rrule: {
        freq: RRule.YEARLY,
        byweekday: RRule.MO,
        bymonth: [12],
        bymonthday: [1, 2],
      },
    },
    {
      id: "new-chums-eve",
      title: "New Chums Eve",
      rrule: {
        freq: RRule.YEARLY,
        dtstart: new Date(2021, 11, 31),
      },
    },
    {
      id: "new-chums-day",
      title: "New Chums Day",
      rrule: {
        freq: RRule.YEARLY,
        dtstart: new Date(2021, 0, 1),
      },
    },
  ],
});

calendar.render();
